import React from 'react';
import { Modal } from 'react-bootstrap';
import ReactPlayer from 'react-player';

const VideoModal = ({ show, onHide, videoUrl }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      contentClassName="custom-video-modal"
    >
      <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
        <ReactPlayer
          url={videoUrl}
          controls
          playing
          width="100%"
          height="100%"
          style={{ position: 'absolute', top: 0, left: 0 }}
        />
        <button
          onClick={onHide}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            background: 'rgba(0,0,0,0.6)',
            color: 'white',
            border: 'none',
            borderRadius: '50%',
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 10,
          }}
        >
          <i className="fas fa-times" style={{ fontSize: 16 }}></i>
        </button>
      </div>
    </Modal>
  );
};

export default VideoModal;
